module.exports = __webpack_public_path__ + "img/eprice-red-round-02.f69a4548.png";